const getParamsFromUrl = () => {
  let url = window.location.href
  let params = {}
  let paramsStr = url.split("?")[1]
  if (paramsStr) {
    let paramsArr = paramsStr.split("&")
    let reg = /(\/?#\/.*)/
    paramsArr.forEach(item => {
      let key = item.split("=")[0]
      let val = item.split("=")[1] || ""
      val = val.toString().replace(reg, "")
      params[key] = val
    })
  }
  if (url.split("?")[2]) {
    const paramsStr2 = url.split("?")[2]
    let paramsArr = paramsStr2.split("&")
    let reg = /(\/?#\/.*)/
    paramsArr.forEach(item => {
      let key = item.split("=")[0]
      let val = item.split("=")[1] || ""
      val = val.toString().replace(reg, "")
      params[key] = val
    })
  }
  return params
}

export default getParamsFromUrl
